import { Component, OnInit, Input, HostListener, ElementRef, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AttachmentSummary, DetailProperty } from '../objects/DetailObject';
import { DomSanitizer } from '@angular/platform-browser';
import { UploadEvent, UploadFile, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { ConfirmationService } from '../services/confirmation.service';
import { ThemeSetting } from '../objects/ThemeObject';
import { ThemeSettingService } from '../services/theme-setting.service';
import { SessionTimerService } from '../services/session-timer.service';
import { AttachmentService } from '../services/attachment.service';
import { NgModel } from '@angular/forms';
import { DetailService } from '../services/detail.service';
import { Subscription } from 'rxjs';
import { ScrollService } from '../services/scroll.service';

@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.css']
})

export class AttachmentComponent implements OnInit, OnDestroy {

  private allowedFormats: string[] = ["pdf", "png", "jpg", "docx", "doc", "xlsx", "xls", "ppt", "pptx", "pdf", "jpg", "jpeg", "gif", "png", "bmp", 
"dtsconfig", "xml", "dtsx", "mdd", "mcf", "txt", "csv", "zip", "rar", "eml"];

  @ViewChild('file') fileControl;
  @ViewChild('fileContainer') fileContainer: ElementRef;
  
  @Input() attachmentIsMultiple:boolean = false;
  @Input() set setComponentId(id:string){
    this.componentId = id;
  }

  @Input() set setProperty(property: DetailProperty){
    this.propertyId = property.PropertyId;
    this.propertyName = property.PropertyName;
    this.propertyDisplay = property.PropertyDisplay;
    this.isEditable = property.PropertyIsEditable;
    this.isOptional = property.PropertyFormControlType.toUpperCase().indexOf("OPTIONAL") > -1;
    if (this.isOptional){
      if (property.PropertyValue == this.defaultGuid){
        this.isNotApplicable = true;
        this.optionalFileToggle({checked : true}, false);
      }
    }
    this.getFileList();
    this.getFilesSettings();
  }

  @Input() set setInvalid(invalid: boolean){
      this.isInvalid = invalid;
  }

  @Output() attachments = new EventEmitter<string>();
  @Output() optionalChanged = new EventEmitter<string>();

  private showConfirmDelete: boolean;
  fileList: AttachmentSummary[] = [];
  private unitSize: string;
  private currentFileId: string;
  private errorMessage: string;
  private maxFileSizeKb: number = 10000;
  private componentId: string;
  private sub1: Subscription;
  propertyId: string;
  propertyDisplay: string;
  propertyName: string;
  isEditable: boolean = false;
  isOptional: boolean = false;
  isNotApplicable: boolean = false;
  allowedFormatsString: string;
  acceptFormatString: string;
  isDeleteAll: boolean = false;
  isFileChange: string;
  isUploading: boolean = false;
  onBlur: boolean = false;
  loaderConfig: any;
  isBusy: boolean = false;
  isInvalid: boolean = false;
  isDisabled: boolean = false;
  defaultGuid: string = "00000000-0000-0000-0000-000000000000";

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if(this.eRef.nativeElement.contains(event.target)) {
      this.onBlur = false;
    } else {
      this.onBlur = true;
      this.currentFileId = null;
      this.isDeleteAll = false;
    }
  }
  
  constructor(private eRef: ElementRef, private sanitizer: DomSanitizer, private confirmationService: ConfirmationService, private themeSettingService: ThemeSettingService,
    private sessionTimerService: SessionTimerService, private attachmentService: AttachmentService, private detailService: DetailService, private scrollService: ScrollService) { 
    this.onBlur = false;

    this.sub1 = this.detailService.currentPropertyFocusChanged$.subscribe(result => {
      if (this.propertyId == result){
        this.scrollService.triggerScrollTo(this.fileContainer);
      }
    });
   }

  onFileChange(event){
    this.errorMessage = null;
    let fileList: FileList = event.target.files;

    if (this.isDisabled) return false;
    if(fileList.length > 0) {
      this.uploadAttachment(fileList, 0);
    }
  }

  uploadAttachment(files: FileList, index:number, uploadSuccess: boolean = false){
    if (this.allowedFormats.indexOf(files[index].name.split('.').pop().toLowerCase()) > -1 && files[index].name.indexOf(".") > -1) {
      if (files[index].size / 1000 < this.maxFileSizeKb){
        this.isUploading = true;
        this.sessionTimerService.resetSessionTimer();
        this.attachmentService.uploadAttachment(this.componentId, this.propertyId, encodeURIComponent(files[index].name), files[index]).subscribe(result=>{
          if(result == "1"){
            index++;
            if (files.length > index){
              this.uploadAttachment(files, index, true);
            }
            else{
              this.getFileList();
              this.isUploading = false;
            }
          }
          else{
            this.getFileList();
            this.isUploading = false;
          }
        }, error => {
          this.isUploading = false;
          this.fileControl.nativeElement.value = "";
        });
      }
      else{
        if (uploadSuccess) this.getFileList();
        this.isUploading = false;
        this.handleFileErrorMessage(FileErrorType.INVALID_SIZE);
      }
      
    }
    else{
      if (uploadSuccess) this.getFileList();
      this.isUploading = false;
      this.handleFileErrorMessage(FileErrorType.INVALID_FORMAT);
      
      
    }
  }

  getFileList(emit:boolean = true){
    if(this.componentId && this.propertyId){
      this.attachmentService.getAttachmentList(this.componentId, this.propertyId).subscribe(result=> {
        if(result){
          this.fileList = JSON.parse(result);
          if (emit) this.attachments.emit(this.fileList.map(x => x.AttachmentId).join(","));
          this.sortFileList();
          this.fileList.forEach(file => {
            //this.requestDownloadFile(file);
          });
        }
        else{
          this.fileList = [];
          if (emit) this.attachments.emit(null);
        }
        this.isFileChange = null;
        this.isUploading = false;
        this.isBusy = false
      }, error => {
        this.isBusy = false;
      });

    }
  }

  sortFileList(){
    this.fileList = this.fileList.sort((a:AttachmentSummary,b:AttachmentSummary) => { 
      if(a.AttachmentName.toLowerCase() > b.AttachmentName.toLowerCase()){
        return 1;
      }else if(a.AttachmentName.toLowerCase() < b.AttachmentName.toLowerCase()){
        return -1;
      }else{
        return 0;
      }
     });
  } 

  getFilesSettings(){
    this.attachmentService.getMaximumFileUploadSize().subscribe(result => {
      if (result){
        this.maxFileSizeKb = Number(result);
      }
    });

    this.attachmentService.getAllowedFileTypes().subscribe(result => {
      if (result){
        this.allowedFormats = result.split(',');
        this.allowedFormatsString = this.allowedFormats.join(' ');
        var array = [];
        this.allowedFormats.forEach(element => {
          var newEl = "." + element;
          array.push(newEl);
        });
    
        this.acceptFormatString = array.toString();
      }
    })
  }
  
  requestDownloadFile(file:AttachmentSummary){
    this.isBusy = true;
    this.attachmentService.downloadFile(file.AttachmentId).subscribe(data=>{
      this.downloadFile(file, data);
    });
    return false;
  }

  downloadFile(file: AttachmentSummary, data: Blob){    
    var a = document.createElement('a');
    a.href = window.URL.createObjectURL(data);
    a.download = file.AttachmentName;
    a.dispatchEvent(new MouseEvent('click'));
    this.isBusy = false;
    //file.AttachmentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(data));
  }

  deleteAll() {
    this.confirmationService.confirm(
      "Delete all files ?",
      "<p class='normal-message'>All files in " + this.propertyDisplay + " will be permanently deleted</p>",
      ["CANCEL, CANCEL", "OK"], false, "", false, "", false, "delete")
      .subscribe((respond) => {
        if (respond.answer == "OK"){
          this.deleteAllConfirmed();
        }
      });
  }

  deleteAllConfirmed(emit: boolean = false){
    this.isBusy = true;
    let attachmentIds = this.fileList.map(a => a.AttachmentId);
    var param: any;
    param = { name: "attachmentIdList", value: JSON.stringify(attachmentIds) };
    
    this.attachmentService.deleteAllFile(param, this.componentId, this.propertyId).subscribe(result => {
      this.fileControl.nativeElement.value = "";
      this.getFileList(emit);
    }, error => {
      this.isBusy = false;
    })
  }

  deleteFile(id:string){
    this.currentFileId = id;
    this.onBlur = false;
  }

  deleteConfirmed(id: string) {
    this.currentFileId = null;
    this.isFileChange = id;
    this.errorMessage = null;
    this.attachmentService.deleteFile(id, this.componentId, this.propertyId).subscribe(data=>{
      this.fileControl.nativeElement.value = "";
      this.onBlur = true;
      this.getFileList();
    });
  }

  ngOnInit() {
    var themes:ThemeSetting = this.themeSettingService.getTheme();
    this.loaderConfig = themes;

    this.allowedFormatsString = this.allowedFormats.join(' ');
    var array = [];
    this.allowedFormats.forEach(element => {
      var newEl = "." + element;
      array.push(newEl);
    });

    this.acceptFormatString = array.toString();
  }

  ngOnDestroy(){
    if (this.sub1) this.sub1.unsubscribe();
  }

  public files: UploadFile[] = [];

  public dropped(event: UploadEvent) {
    this.files = event.files;
    if (this.isDisabled) return false;
    if (this.files.length > 1 && !this.attachmentIsMultiple){
      this.errorMessage = "Only one file is allowed for " + this.propertyDisplay.toLowerCase() + " field";
    }
    else{
      this.errorMessage = null;
      this.droppedAttachments(this.files, 0);
    }
  }

  droppedAttachments(fileList: UploadFile[], index: number, uploadSuccess: boolean = false){
    var droppedFile = fileList[index];
    var fileName = droppedFile.fileEntry.name;
    // Is it a file?
    if (droppedFile.fileEntry.isFile){
      if (this.allowedFormats.indexOf(fileName.split('.').pop().toLowerCase()) > -1 && fileName.indexOf(".") > -1) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          if (file.size / 1000 < this.maxFileSizeKb){
            this.isUploading = true;
            this.sessionTimerService.resetSessionTimer();
            this.attachmentService.uploadAttachment(this.componentId, this.propertyId, encodeURIComponent(file.name), file).subscribe(result=>{
              if(result == "1"){
                index++;
                if (fileList.length > index && this.attachmentIsMultiple){
                  this.droppedAttachments(fileList, index, true);
                }
                else{
                  this.getFileList();
                  this.isUploading = false;
                }
              }
              else{
                this.getFileList();
                this.isUploading = false;
              }
            }, error => {
              this.isUploading = false;
              this.fileControl.nativeElement.value = "";
            });
          }
          else{
            if (uploadSuccess) this.getFileList();
            this.isUploading = false;
            this.handleFileErrorMessage(FileErrorType.INVALID_SIZE);
          }
          
        });
      }
      else{
        if (uploadSuccess) this.getFileList();
        this.handleFileErrorMessage(FileErrorType.INVALID_FORMAT);
      }
    } else {
      // It was a directory (empty directories are added, otherwise only files)
      const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      console.log(droppedFile.relativePath, fileEntry);
    }
  }
  
  handleFileErrorMessage(fileErrorType: FileErrorType){
    switch(fileErrorType){
      case FileErrorType.INVALID_FORMAT:
        this.errorMessage = "File format is not valid";
      break;
      case FileErrorType.INVALID_SIZE: 
        if (this.attachmentIsMultiple) {
          this.errorMessage = "Please make sure each file size does not exceed the maximum file upload size";
        }
        else{
          this.errorMessage = "Please make sure the file size does not exceed the maximum file upload size";
        }
      break;
    }
  }

  optionalFileToggle(event: any, userInteract: boolean = true){
    this.isDisabled = event.checked;
    if (this.isDisabled && userInteract){
      this.deleteAllConfirmed(false);
      this.attachments.emit(this.defaultGuid);
    }
    this.optionalChanged.emit(event.checked);
  }

  public fileOver(event){
    //console.log(event);
  }

  public fileLeave(event){
    //console.log(event);
  }
}

export enum FileErrorType {
  INVALID_FORMAT,
  INVALID_SIZE
}